import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const archivedProjectsDirectoryRoute: InvariantJiraRoute = {
	name: 'archived-projects-directory',
	path: '/jira/settings/projects/archive',
	exact: true,
};
